import { useSyncExternalStore } from "react";

/**
 * Дали в момента се тегли код на модул (`lazyPage.tsx`) и дали на екрана е
 * резервното съдържание на общата Suspense граница (`PageLoading`). Чете го
 * единственият spinner на механизма — `PageLoadingIndicator`.
 */
export type PageLoadStatus = "idle" | "loading" | "fallback";

let pendingLoads = 0;
let shownFallbacks = 0;
const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getStatus(): PageLoadStatus {
  if (shownFallbacks > 0) return "fallback";
  return pendingLoads > 0 ? "loading" : "idle";
}

/** Отчита зареждането, докато обещанието е висящо. */
export function trackPageLoad<T>(loading: Promise<T>): Promise<T> {
  pendingLoads += 1;
  notify();
  return loading.finally(() => {
    pendingLoads -= 1;
    notify();
  });
}

/** Отбелязва показано резервно съдържание; връща функцията, която го сваля. */
export function markFallbackShown(): () => void {
  shownFallbacks += 1;
  notify();
  return () => {
    shownFallbacks -= 1;
    notify();
  };
}

export function usePageLoadStatus(): PageLoadStatus {
  return useSyncExternalStore(subscribe, getStatus);
}
